import React, { useState, useEffect } from 'react'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import PiePage from '../../utils/PiePage.component'
import InputField from '../../utils/InputMUI'
import SelectField from '../../utils/SelectMUI'
import { getZipBranchDetailApi, SaveUpdateAccountDetailsDealer, getCommunityAccountDetailsBycommunityId } from '../ActionCreator'


const accountTypeData = [
    {
        code: "SavingAccount",
        name: "Saving Account",
    },
    {
        code: "currentAccount",
        name: "Current Account",
    },
]
export default function BasicDetails({ handlePage, handleTabs, communityId, Detaildata }) {
    const [responseMsg, setresponseMsg] = useState("")
    const [errors, setErrors] = useState({})
    const [loaderState, setloaderState] = useState(false)
    const [ObjectData, setObjectData] = useState({
        accNumber: '',
        nameInBank: '',
        ifsc: '',
        bank: '',
        branch: '',
        accountType: "",


    })


    useEffect(() => {
        if (Detaildata?.rowData?.communityId) {
            setloaderState(true)
            getCommunityAccountDetailsBycommunityId(Detaildata?.rowData?.communityId, (callback) => {
                console.log("Detaildata?.communityId", callback)
                if (callback && callback?.status == 200  && callback?.message == "success") {
                    setObjectData({
                        accNumber: callback?.data?.accountNumber || '',
                        nameInBank: callback?.data?.nameAsBankAccount || '',
                        ifsc: callback?.data?.ifscCode || '',
                        bank: callback?.data?.bankName || '',
                        branch: callback?.data?.branchName || '',
                        accountType: callback?.data?.accountType || "",
                    })
                } else {
                    setObjectData({
                        accNumber: '',
                        nameInBank: '',
                        ifsc: '',
                        bank: '',
                        branch: '',
                        accountType: "",
                    })
                }
                setloaderState(false)
            })
        }
    }, [Detaildata?.rowData])


    const inputChange = (e, type) => {

        let changeObjectData = Object.assign({}, ObjectData)

        if (type === 'ifsc' && changeObjectData[type].length == 10) {


            // if (e.length == 11) {
            changeObjectData[type] = e
            const data = {
                code: e,
                type: 'branch'
            }
            setloaderState(true)
            getZipBranchDetailApi(data, (callback) => {
                setloaderState(false)
                if (callback.status === 'success') {
                    let changeObjectData = Object.assign({}, ObjectData)
                    changeObjectData[type] = e
                    if (type === 'ifsc') {
                        changeObjectData.bank = callback.branchName
                        changeObjectData.branch = callback.branchCode

                    }
                    setObjectData(changeObjectData)
                } else {
                    setloaderState(false)

                    alert('Please enter correct pincode')
                }
            })

            // } 


        } else {
            changeObjectData[type] = e
        }

        setObjectData(changeObjectData)

    }


    const saveHandler = (e) => {
        if (e === 'save') {
            setloaderState(true)
            const obj = { ...ObjectData, communityId: communityId }
            SaveUpdateAccountDetailsDealer(obj, (callback) => {
                setloaderState(false)
                console.log(callback)
                handlePage("", "list")
            })
        } else if (e === 'close') {
            handlePage("", "list")
        }
    }

    return (
        <>
            <div className='container hoverNone card'>
                {loaderState ?
                    <Loader />
                    : null}

                <PiePage
                    totalPage={3}
                    currentPage={3}
                    heading={'Add Bank Info'}
                />


                <div className='row'>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Bank Account Number"
                            variant="outlined"
                            value={ObjectData.accNumber}
                            name="accNumber"
                            id="accNumber"
                            type="number"
                            onChange={e => inputChange(e, 'accNumber')}
                            size="small"
                        // required={true}
                        />
                        {/* {
                            errors?.address &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.address}</div>
                        } */}

                    </div>
                    <div className='col-sm-4 col-xs-12  ' style={{ marginBottom: '12px' }} >
                        <InputField
                            label="Bank Account Name"
                            variant="outlined"
                            value={ObjectData.nameInBank}
                            name="nameInBank"
                            id="nameInBank"
                            type="text"
                            onChange={e => inputChange(e, 'nameInBank')}
                            size="small"

                        />
                        {/* {
                            errors?.area &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.area}</div>
                        } */}


                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="IFSC code"
                            variant="outlined"
                            value={ObjectData.ifsc}
                            name="ifsc"
                            id="ifsc"
                            type="text"
                            onChange={e => inputChange(e, 'ifsc')}
                            size="small"

                        />
                        {/* {
                            errors?.email &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.email}</div>
                        } */}

                    </div>
                </div>

                <div className="row">
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="Bank Name"
                            variant="outlined"
                            value={ObjectData.bank}
                            name="bank"
                            id="bank"
                            type="text"
                            onChange={e => inputChange(e, 'bank')}
                            size="small"

                        />
                        {/* {
                            errors?.alternateEmail &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.alternateEmail}</div>
                        } */}

                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="Branch Name"
                            variant="outlined"
                            value={ObjectData.branch}
                            name="branch"
                            id="branch"
                            type="text"
                            onChange={e => inputChange(e, 'branch')}
                            size="small"

                        />
                        {/* {
                            errors?.multipleEmail &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.multipleEmail}</div>
                        } */}

                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <SelectField
                            value={ObjectData.accountType}
                            label="Account Type"
                            onChange={e => inputChange(e, 'accountType')}
                            name="accountType"
                            data={accountTypeData}
                            size={'small'}

                        />
                        {/* {
                            errors?.multipleEmail &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.multipleEmail}</div>
                        } */}

                    </div>

                </div>



                <div className='mb-3 mt-2 row' style={{ margin: '15px 0' }}>
                    <div className="form-text text-danger">{responseMsg}</div>
                    <div className="col-12 text-center">

                        <button className="cred-btn cancel-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('close')}>Close</button>

                        <button className="cred-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('save')}>Save</button>
                    </div>
                </div>
            </div>
        </>
    )
}
